import React from "react";
//styles
import styles from "./Index.module.css"
import stylesEmployee from "../OmOs/LedelseAnsatte/Index.module.css"
//components
import PageHeader from "../../PageHeader/PageHeader";
import Profil from "../components/Profil";
import PageState from "../components/PageState";
import PageInfo from '../components/PageInfo.js';
//Utils
import renderItem from '../components/RenderItems.js';

export default function Kontakt() {
    return(
        <PageState
            pageName="Kontakt"
            render={({ data, sections, sectionNames }) => {
                
                const{Sec1, Sec2, Sec3} = data


                return (
                    <div>
                        <PageHeader
                            title={data.PageHeader.title}
                            description={data.PageHeader.text}
                            image={data.PageHeader.imageUrl}
                            sections={sections}
                            sectionNames={sectionNames}/>
                        <section id={Sec1.secId} className={styles.section1}>
                                <div className={styles.wrapper}>
                                    <div className={styles.textbox}>
                                        <h2>{Sec1.header}</h2>
                                        <p>{Sec1.address}</p>
                                    </div>
                                    <iframe
                                        title="Hillerød Frimenighed Map"
                                        loading="lazy"
                                        allowFullScreen
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.403568308245!2d12.303921076795536!3d55.92717705914171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464da441a2b5a4c7%3A0x29e3b5f19e37a68e!2sAnsgarvej%2010%2C%203400%20Hiller%C3%B8d!5e0!3m2!1sen!2sdk!4v1706523456789!5m2!1sen!2sdk"
                                    ></iframe>
                                </div>
                        </section>
                        <section id={Sec2.secId} className={styles.section2}>
                            <div className={stylesEmployee.employees}>
                                {(Sec2.items || []).map((item) => renderItem(item, Sec2[item.sectionKey]))}
                            </div>
                        </section>
                        {Sec3 && 
                            <section id={Sec3.secId} className={styles.section3}>
                                <PageInfo title={Sec3.header} description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>}/>
                                <div className={stylesEmployee.employees}>
                                    {(Sec3.items || []).map((item) => renderItem(item, Sec3[item.sectionKey]))}
                                </div>
                            </section>}
                    </div>
                );
            }
        }/>
    );
}